import { css } from '@emotion/core';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import Icon from '@veeva/corgix/icon';
import useMessageService from '../services/i18n/useMessageService';
import colors from '../theme/colors';
import InputField from './InputField';
import getTargetAttribute from '../services/getTargetAttribute';

const propTypes = {
    error: PropTypes.bool,
    errorMessage: PropTypes.node,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const PasswordField = ({ error, errorMessage, label, onChange, onKeyUp, placeholder, value }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [[passwordLabel = 'Password']] = useMessageService(['general.password']);

    const handleSubmit = (e) => {
        if (e.code === 'Enter') {
            onKeyUp?.();
        }
    };

    return (
        <InputField
            css={css`
                width: 100%;
            `}
            error={error}
            errorMessage={errorMessage}
            label={label}
            placeholder={placeholder || passwordLabel}
            onChange={onChange}
            onKeyUp={handleSubmit}
            renderIcons={() => [
                <Icon
                    key="lock-icon"
                    className="prepend"
                    color={value ? null : colors.lightGray}
                    size="md"
                    type={faLock}
                />,
                <Icon
                    key="eye-icon"
                    color={value ? null : colors.lightGray}
                    onClick={() => setShowPassword(!showPassword)}
                    size="md"
                    type={showPassword ? faEye : faEyeSlash}
                />,
            ]}
            type={showPassword ? 'text' : 'password'}
            value={value}
            ariaLabel="password-field"
            data-target={getTargetAttribute('password-field')}
        />
    );
};

PasswordField.propTypes = propTypes;
export default PasswordField;
